// extracted by mini-css-extract-plugin
module.exports = {"Ads__item":"pk0i"};